import classNames from 'classnames';
import T from 'prop-types';
import React, { useEffect, useState } from 'react';
import AnchorNavMultiLevelMobile from '../AnchorNavMultiLevel/mobile';
import { isMediumViewport } from '../Hooks/useMedia';
import ListSelect from '../ListSelect';

const InfoBanner = (props) => {
  const isMobile = isMediumViewport();
  const [activeButton, setActiveButton] = useState(null);

  const classes = classNames({
    'info-banner': true,
    'info-banner--offset': props.IsHidden && props.IsMobile,
    [`info-banner__type--${props.InformationType}`]: props.InformationType,
    [props.className]: props.className,
  });

  const SelectedProfession = props.Switch?.Items?.filter(
    (item) => item.Selected
  ).map((item) => item.Title);

  const handleButtonClick = (button) => {
    setActiveButton((prevActive) => (prevActive !== button ? button : null));
  };

  const closeNav = () => {
    document.body.removeAttribute('class');
    setActiveButton(null);
  };

  useEffect(() => {
    document.body.removeAttribute('class');
    if (activeButton) {
      document.body.classList.add('no-scroll');
    }
  }, [activeButton]);

  const [current, setCurrent] = useState('');

  useEffect(() => {
    if (!props.AnchorNavigation && !isMobile) {
      return;
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const elements = document.querySelectorAll('.anchor-nav-multi-item');
      elements.forEach((element) => {
        if (element.offsetTop - 80 <= scrollPosition) {
          setCurrent(element.getAttribute('id'));
        } else {
          return;
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <>
      <div className={classes}>
        <div className="info-banner__content">
          {props.Subject && (
            <div className="info-banner__first-item">
              <span className="info-banner__first-item__container">
                <span
                  className="info-banner__subject"
                  data-cy="info-banner-subject"
                >
                  {props.Subject}
                </span>

                {props.Title && !isMobile && (
                  <span
                    className="info-banner__title"
                    data-cy="info-banner-title"
                  >
                    {props.Title}
                  </span>
                )}
                {isMobile && SelectedProfession && (
                  <button
                    className={
                      activeButton === 'profession'
                        ? 'info-banner__btn--active'
                        : ''
                    }
                    onClick={() => handleButtonClick('profession')}
                    aria-controls="info-banner-modal"
                    aria-expanded={!!activeButton}
                  >
                    {SelectedProfession}
                  </button>
                )}
              </span>
            </div>
          )}
          {isMobile && (
            <div className="info-banner__second-item">
              {props.AnchorHeading && (
                <button
                  className={
                    activeButton === 'anchor-nav'
                      ? 'info-banner__btn--active'
                      : ''
                  }
                  onClick={() => handleButtonClick('anchor-nav')}
                  aria-controls="info-banner-modal"
                  aria-expanded={!!activeButton}
                >
                  {props.AnchorHeading}
                </button>
              )}
            </div>
          )}

          {props.Switch && !isMobile && (
            <ListSelect {...props.Switch} />
          )}
        </div>
        <div
          className={classNames({
            'info-banner__modal': true,
            'info-banner__modal--visible': activeButton,
          })}
          aria-controls="info-banner-modal"
          aria-expanded={!!activeButton}
        >
          {props.Switch &&
            isMobile &&
            activeButton === 'profession' && <ListSelect {...props.Switch} />}

          {props.AnchorNavigation &&
            isMobile &&
            activeButton === 'anchor-nav' && (
              <AnchorNavMultiLevelMobile
                CurrentActive={current}
                CloseNav={closeNav}
                AnchorNavigation={props.AnchorNavigation}
              />
            )}
        </div>
      </div>
    </>
  );
};

InfoBanner.propTypes = {
  Title: T.string,
  Subject: T.string,
  InformationType: T.string,
  className: T.string,
};

export default InfoBanner;
